import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Tree } from 'primeng/tree';
import { ActionService } from 'src/app/services/actions/action.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DocumentType, DocumentTypeTreeNode } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeItemComponent } from './document-type-item/document-type-item.component';
import { DocumentTypeBaseComponent } from './document-types-base.component';

interface DisplayCategory {
    name: string;
    id: number;
}

@Component({
    selector: 'app-document-type-mgr',
    templateUrl: './document-types.component.html',
    styleUrls: ['./document-types.component.scss']
})

export class DocumentTypeManagerComponent extends DocumentTypeBaseComponent implements OnInit, AfterViewInit {
    constructor(
        public actionService: ActionService,
        public configurationService: ConfigurationService

    ) {
        super(configurationService, actionService);
    }

    selectedDocumentType: TreeNode;
    _categorizedDocTypes: TreeNode[] = [];

    get categorizedDocTypes() {
        return this._categorizedDocTypes;
    }
    set categorizedDocTypes(value: TreeNode[]) {
        this._categorizedDocTypes = value;
    }

    documentTypes: DocumentTypeTreeNode[];
    categoryOptions: DisplayCategory[];
    selectedCategory: DisplayCategory;
    searchValue: string;
    ready: boolean = false;

    @ViewChild(DocumentTypeItemComponent, { static: false }) documentTypeItemComponent: DocumentTypeItemComponent;
    @ViewChild('docTypeTree', { static: false }) docTypeTree: Tree;

    async ngOnInit() {

        this.documentTypes = await this.getDocumentTypes();
        this.categorizedDocTypes = this.getDocumentTypesByCategory();

        this.categoryOptions = [
            { name: 'By Category', id: 1 },
            //   { name: 'By Namespace', id: 2 },
            { name: 'By Type and Version', id: 3 },
        ];
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.ready = true;
        });
    }

    getDocTypeTreeNodeAsTreeNode(docType: DocumentTypeTreeNode): TreeNode<DocumentTypeTreeNode> {

        const docTypeNode = {
            label: `${docType.description ?? docType.type} - v${docType.version ?? ''}`,
            key: docType.id.toString(),
            icon: "fal fa-file",
            leaf: true,
            data: null
        } as TreeNode<DocumentTypeTreeNode>;

        return docTypeNode;
    }

    getDocTypeAsDocTypeTreeNode(docType: DocumentType): DocumentTypeTreeNode {

        const docTypeTreeNode = new DocumentTypeTreeNode();

        docTypeTreeNode.id = docType.id;
        docTypeTreeNode.type = docType.type;
        docTypeTreeNode.description = docType.description;
        docTypeTreeNode.version = docType.version;
        docTypeTreeNode.category = docType.metadata.category;

        return docTypeTreeNode;
    }

    documentTypeSelected(event) {
        if (event.node.leaf) {
            this.documentTypeItemComponent.documentTypeId = +this.selectedDocumentType.key;
        }
    }

    getDocumentTypesByCategory() {
        let categorizedDocTypes: TreeNode[] = [];

        this.documentTypes.forEach(docType => {

            let category = (this.isEmptyString(docType.category)) ? 'Not Categorized' : docType.category;

            if (!categorizedDocTypes.some(node => node.label === category)) {
                categorizedDocTypes.push({
                    label: category,
                    data: `${docType.category ?? 'Not Categorized'} document type`,
                    icon: "fal fa-folder",
                    expanded: false,
                    leaf: false,
                    selectable: false,
                    children: []
                } as TreeNode);
            }

            const parentNode = categorizedDocTypes.filter(node => (node.label === docType.category))[0] ??
                categorizedDocTypes.filter(node => (node.label === 'Not Categorized'))[0];

            let docTypeNode = this.getDocTypeTreeNodeAsTreeNode(docType);
            docTypeNode.parent = parentNode;

            parentNode.children?.push(docTypeNode);

        });

        return categorizedDocTypes;
    }

    getDocumentTypesByTypeAndVersion() {
        let categorizedDocTypes: TreeNode[] = [];

        this.documentTypes.forEach(docType => {

            if (!categorizedDocTypes.some(node => node.type === docType.type)) {
                categorizedDocTypes.push({
                    label: docType.description,
                    type: docType.type,
                    data: docType.description,
                    icon: "fal fa-folder",
                    expanded: false,
                    leaf: false,
                    children: []
                } as TreeNode);
            }

            const parentNode = categorizedDocTypes.filter(node => node.type === docType.type)[0];

            let docTypeNode = this.getDocTypeTreeNodeAsTreeNode(docType);

            docTypeNode.parent = parentNode;

            parentNode.children?.push(docTypeNode);
        });

        return categorizedDocTypes;
    }

    categorizeByChanged(event) {
        this.changeDocumentTypeCategorization(event.value.id);
    }

    changeDocumentTypeCategorization(categoryTypeId: number) {
        switch (categoryTypeId) {
            case 1:
                this._categorizedDocTypes = this.getDocumentTypesByCategory();
                break;
            case 2:
                break;
            case 3:
                this._categorizedDocTypes = this.getDocumentTypesByTypeAndVersion();
                break;
            default:
                break;
        }
    }

    filterConfig(value: string) {
        this.docTypeTree._filter(value);
    }

    clearSearch() {
        this.docTypeTree.resetFilter();
        this.searchValue = "";
    }

    addDocumentType() {
        this.documentTypeItemComponent.documentTypeId = 0;
        this.documentTypeItemComponent.docTypeForm.clearForm();
    }

    async documentTypeRemoved() {
        this.documentTypes = await this.getDocumentTypes();
        this.changeDocumentTypeCategorization(this.selectedCategory.id);
    }

    async documentTypeAdded(event: DocumentType) {
        let docTypeTreeNode = this.getDocTypeAsDocTypeTreeNode(event);
        this.documentTypes.push(docTypeTreeNode);
        this.changeDocumentTypeCategorization(this.selectedCategory.id);

        const categoryNode = this._categorizedDocTypes.filter(treeNode => treeNode.label === docTypeTreeNode.category)[0];
        categoryNode.expanded = true;
        this.selectedDocumentType = categoryNode.children.filter(docTypeNode => docTypeNode.key === docTypeTreeNode.id.toString())[0];
    }

    private isEmptyString(value: any): boolean {
        return (typeof value !== 'string' || value?.trim().length === 0);
    }

}

